"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variant = _interopRequireDefault(require("@styled-system/variant"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @property { HTMLelement } as
 * @property {{ 'primary' | 'ghost' | 'ghost-blue' }} variant
 */
var ButtonBaseComponent = (0, _styledComponents["default"])('button').attrs(function (props) {
  return {
    className: "gf-styled__button__".concat(props.variant)
  };
}).withConfig({
  displayName: "button-base__ButtonBaseComponent",
  componentId: "sc-1sy0u5g-0"
})(["display:flex;align-items:center;justify-content:center;box-shadow:", ";font-family:\"Space Grotesk\",sans-serif;color:var(--color);background-color:var(--background-color);border:0.125rem solid var(--border-color);border-radius:10em;padding:0.375rem 1.125rem;text-decoration:unset;white-space:nowrap;> .button-icon-wrapper{margin-left:0.625rem;svg{display:flex;}}@media ", "{box-shadow:none;justify-content:flex-start;&:hover{color:var(--color);box-shadow:", ";background-color:var(--hover-bg-color);border-color:var(--hover-border-color);}}@media ", "{width:fit-content;}", ""], function (props) {
  return props.theme.effects.boxShadow.button;
}, function (props) {
  return props.theme.queries.tabletAndUp;
}, function (props) {
  return props.theme.effects.boxShadow.button;
}, function (props) {
  return props.theme.queries.desktopAndUp;
}, function (props) {
  return (0, _variant["default"])({
    variants: {
      primary: {
        '--color': props.theme.colors.white,
        '--background-color': props.theme.colors.magic.buttonBase,
        '--hover-bg-color': props.theme.colors.magic.base,
        '--border-color': props.theme.colors.magic.buttonBase,
        '--hover-border-color': props.theme.colors.magic.base
      },
      ghost: {
        '--color': props.theme.colors.white,
        '--background-color': 'transparent',
        '--hover-bg-color': props.theme.colors.magic.base,
        '--border-color': props.theme.colors.white,
        '--hover-border-color': props.theme.colors.magic.base
      },
      'ghost-blue': {
        '--color': props.theme.colors.magic.base,
        '--background-color': 'transparent',
        '--hover-bg-color': 'transparent',
        '--border-color': props.theme.colors.magic.base,
        '--hover-border-color': props.theme.colors.magic.base
      }
    }
  });
});
ButtonBaseComponent.propTypes = {
  variant: _propTypes["default"].oneOf(['primary', 'ghost', 'ghost-blue'])
};
ButtonBaseComponent.defaultProps = {
  variant: 'primary'
};
var _default = ButtonBaseComponent;
exports["default"] = _default;